__turbopack_context__.v({
  "body": "_0hiYhG_body",
  "calendarArea": "_0hiYhG_calendarArea",
  "calendarDay": "_0hiYhG_calendarDay",
  "closeButton": "_0hiYhG_closeButton",
  "footer": "_0hiYhG_footer",
  "footerActions": "_0hiYhG_footerActions",
  "header": "_0hiYhG_header",
  "modalCard": "_0hiYhG_modalCard",
  "presetList": "_0hiYhG_presetList",
  "presets": "_0hiYhG_presets",
  "sectionLabel": "_0hiYhG_sectionLabel",
  "selectionCard": "_0hiYhG_selectionCard",
  "selectionPanel": "_0hiYhG_selectionPanel",
  "tipCard": "_0hiYhG_tipCard",
  "triggerLabel": "_0hiYhG_triggerLabel",
});
